function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createHook } from "reakit-system/createHook";
import { createComponent } from "reakit-system/createComponent";
import { useSelectItem } from "./SelectItem";
import { SELECT_OPTION_KEYS } from "./__keys";
export var useSelectOption = createHook({
  name: "SelectOption",
  compose: useSelectItem,
  keys: SELECT_OPTION_KEYS,

  useProps(_, htmlProps) {
    return _objectSpread({
      role: "option"
    }, htmlProps);
  }

});
export var SelectOption = createComponent({
  as: "div",
  memo: true,
  useHook: useSelectOption
});
//# sourceMappingURL=SelectOption.js.map